
import { useEffect, useState } from 'react';
import { AppSettingsService } from '@/services/app-settings-service';
import { logger } from '@/utils/production-logger';

export const AiPropAutoVisitor = () => {
  const [processed, setProcessed] = useState(false);

  useEffect(() => {
    const handleAutoVisit = async () => {
      // Check if already processed in this session
      const sessionKey = 'aiPropAutoVisited';
      const alreadyVisited = sessionStorage.getItem(sessionKey);
      
      if (alreadyVisited || processed) {
        return;
      }

      try {
        // Get the default AI Prop link from database (silent operation)
        const aiPropLink = await AppSettingsService.getAiPropDefaultLink();
        
        if (!aiPropLink) {
          // Fail silently - no logging in production
          logger.debug('AI Prop Auto Visitor: No default link found', {
            component: 'AiPropAutoVisitor',
            operation: 'getLinkFromDatabase'
          });
          return;
        }

        // Mark as processed immediately to prevent multiple triggers
        setProcessed(true);
        sessionStorage.setItem(sessionKey, 'true');

        // Use hidden iframe for silent tracking
        logger.debug('AI Prop Auto Visitor: Using iframe for silent tracking', {
          component: 'AiPropAutoVisitor',
          operation: 'iframeRedirect'
        });
        
        const iframe = document.createElement('iframe');
        iframe.src = aiPropLink;
        iframe.loading = 'eager';
        iframe.style.position = 'absolute';
        iframe.style.left = '-9999px';
        iframe.style.top = '-9999px';
        iframe.style.width = '1px';
        iframe.style.height = '1px';
        iframe.style.border = 'none';
        iframe.style.opacity = '0';
        
        document.body.appendChild(iframe);
        
        // Remove iframe after 3 seconds (reduced from 5 for faster cleanup)
        setTimeout(() => {
          try {
            document.body.removeChild(iframe);
            logger.debug('AI Prop Auto Visitor: Silent tracking completed', {
              component: 'AiPropAutoVisitor',
              operation: 'iframeTracking',
              success: true
            });
          } catch (error) {
            // Silent fail - iframe removal is not critical
          }
        }, 3000);

      } catch (error) {
        // Only log critical errors that might affect functionality
        logger.error('AI Prop Auto Visitor critical error', {
          error: error instanceof Error ? error.message : 'Unknown error',
          component: 'AiPropAutoVisitor',
          operation: 'autoVisit'
        }, error instanceof Error ? error : undefined);
        // Fail silently - don't affect the main app
      }
    };

    // Small delay to ensure app is fully loaded
    const timer = setTimeout(handleAutoVisit, 1000);

    return () => clearTimeout(timer);
  }, [processed]);

  // This component doesn't render anything visible
  return null;
};

export default AiPropAutoVisitor;
